export enum ClaimStates {
    COMMERCIAL_BLOCK = '92',
    EMISSION_BLOCK = '94',
    TECHNICAL_BLOCK = '91',
    DEACTIVATED = '99',
    DEACTIVATED_DUE_TO_DUPLICITY = '93',
    DEACTIVATED_DUE_TO_REPLACEMENT = '90',
    IN_PROCESS = '1',
    LEGAL_PROCEEDINGS = '95',
    PRESCRIBED = '99',
    REJECTED = '96',
    REHABILITATED = '97',
    COMPLETED = '2',
}